export default __webpack_public_path__ + "static/media/image1.988b0b16.png";